// Function loadCareSlider loads the CareSlider class by dynamically importing the js on demand if needed

export function loadCareSlider($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="CareSlider"]');

	if(!$wg) {
		// console.info('CareSlider: no widget found');
		return Promise.reject('CareSlider widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-care-slider-chunk" */ '../widgets/careSlider').then(wg => {

		const { CareSlider } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="CareSlider"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new CareSlider($wg) );
				if (instances.length === $wgCol.length) return instances;
			});

		} else {
			return new CareSlider($wg);
		}


	}).catch(error => error+'An error occurred while loading the CareSlider widget');

}
